export const NotFound = () => {
  return (
    <div>
      <h1 style={{ color: "#fff" }}>Not Found</h1>
    </div>
  );
};
